import { ReactElement } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { dashboardRoutes } from '../../../dashboard/dashboard.routes';
import { itsmRoutes } from '../../../itsm/itsm.routes';
import { servicesRoutes } from '../../../network-services/network-services.routes';
import { statisticsRoutes } from '../../../statistics/statistics.routes';
import { topologyRoutes } from '../../../topology/topology.routes';
import { AppRoutesConfig } from '../../config';

export const AppRouter = (): ReactElement | null => {
  return useRoutes([
    {
      path: AppRoutesConfig.Main,
      element: <Navigate to={AppRoutesConfig.Dashboard} />,
    },
    {
      path: AppRoutesConfig.Dashboard,
      children: dashboardRoutes,
    },
    {
      path: AppRoutesConfig.Services,
      children: servicesRoutes,
    },
    {
      path: AppRoutesConfig.Itsm,
      children: itsmRoutes,
    },
    {
      path: AppRoutesConfig.Statistics,
      children: statisticsRoutes,
    },
    {
      path: AppRoutesConfig.Topology,
      children: topologyRoutes,
    },
  ]);
};
